module.exports = __webpack_public_path__ + "static/sea_spawn-611102cf0d60b7e571a190510b27ec87.jpeg";